module.exports = __webpack_public_path__ + "img/order-list.e2ffd0bf.svg";